import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c4f6250"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col p-1.5 md:p-1.5 flex-grow min-w-0" }
const _hoisted_2 = { class: "flex justify-start items-center gap-x-1 md:gap-x-1.5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-[15px] font-bold text-negative" }, "!", -1))
const _hoisted_4 = { class: "min-w-0 flex-grow" }
const _hoisted_5 = { class: "flex justify-start gap-x-1 md:gap-x-1.5 -mt-0.5 md:-mt-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-[14px] md:w-[20px] h-[8px] md:h-[20px] shrink-0" }, null, -1))
const _hoisted_7 = { class: "mt-auto w-full" }
const _hoisted_8 = {
  key: 0,
  class: "w-full h-[14px] md:h-[18px] rounded-sm bg-white/30"
}
const _hoisted_9 = {
  key: 1,
  class: "flex justify-start gap-x-1 md:gap-x-1.5"
}
const _hoisted_10 = { class: "group-buttons w-full flex items-center justify-center gap-1 md:gap-2 flex-wrap" }

import { computed } from 'vue'
import { getInitialsChar } from '@/utils/string'
import { nameInitials, stripHonorific } from '@/utils/stationDisplay'
import { resolveAvatarSrc } from '@/utils/avatar'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'
import PermanenceRecordIcon from '@/assets/icons/checks/permanence_registro.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import {
  mdiTextBoxCheck,
  mdiAccountAlert,
  mdiClockAlertOutline,
  mdiClockCheckOutline,
  mdiClockEnd
} from '@mdi/js'
import {
  DoctorStationStatus,
  doctorStationStatusTranslate
} from '@/translations/doctor.station.status'
import {
  DoctorStationReminderStatus,
  ExceptionSummaryStatus
} from '@/Network/Types/Responses/StationResponses'
import type { PostStationCellStatus } from '@/Network/Types/Responses/StationResponses'
import { useStationRowStyle, type StationRowCellType } from './useStationRowStyle'

export type CellTypes = StationRowCellType


export default /*#__PURE__*/_defineComponent({
  __name: 'withIcon',
  props: {
    tableType: { default: 'EXTRA' },
    name: { default: '' },
    text: { default: '' },
    minimal: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    solid: { type: Boolean, default: false },
    crm: { default: '' },
    success: { type: Boolean, default: true },
    error: { type: Boolean, default: true },
    waiting: { type: Boolean, default: true },
    pendences: { type: Boolean, default: true },
    photo: { default: '' },
    hasObservations: { type: Boolean, default: false },
    doctorPending: { type: Boolean, default: false },
    doctorConfirmed: { type: Boolean, default: false },
    doctorStationStatus: { default: DoctorStationStatus.SEM_STATUS },
    ourTeam: { type: Boolean, default: false },
    doctorStationReminderStatus: { default: DoctorStationReminderStatus.PENDING },
    isAlert: { type: Boolean, default: false },
    requiredCheckNotOurTeam: { type: Boolean },
    requiredCheckOurTeam: { type: Boolean },
    npsScore: { default: null },
    exceptionSummaryStatus: { default: null },
    postStationStatus: { default: null },
    permanenceTooltip: { default: null },
    colorOverride: { default: null },
    mobile: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;



const { flags } = useFeatureFlags()

const resolvedPhoto = computed(() => resolveAvatarSrc(props.photo))
/** QA-11: no celular as iniciais saem do nome sem "Dr./Dra." (AS); o desktop segue igual ao main. */
const avatarInitials = computed(() =>
  props.mobile ? nameInitials(stripHonorific(props.name)) : getInitialsChar(props.name)
)

// Cor, alerta e ícones vêm do composable (reusado pelo StationListCard do celular).
const {
  stationIsAlert,
  npsRingStyle,
  colorDefination,
  defineOurTeamBgColor,
  isAlertTextColor,
  notShowStatusIcon,
  exceptionIconPath,
  exceptionIconColor,
  exceptionTooltipText,
  postStationIconColor,
  postStationTooltipText
} = useStationRowStyle(() => ({
  tableType: props.tableType,
  solid: props.solid,
  ourTeam: props.ourTeam,
  isAlert: props.isAlert,
  colorOverride: props.colorOverride,
  requiredCheckOurTeam: props.requiredCheckOurTeam,
  requiredCheckNotOurTeam: props.requiredCheckNotOurTeam,
  exceptionSummaryStatus: props.exceptionSummaryStatus,
  postStationStatus: props.postStationStatus,
  npsScore: props.npsScore,
  hasObservations: props.hasObservations,
  doctorPending: props.doctorPending,
  doctorConfirmed: props.doctorConfirmed,
  doctorStationStatus: props.doctorStationStatus,
  permanenceTooltip: props.permanenceTooltip
}))

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "row-table w-full justify-center h-[72px] md:h-[105px] overflow-hidden",
    style: _normalizeStyle(`background: ${_unref(colorDefination).bg};`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`${_unref(colorDefination).stripe} w-2 md:w-3`),
      style: _normalizeStyle(_unref(colorDefination).stripeStyle)
    }, null, 6),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(stationIsAlert))
          ? (_openBlock(), _createBlock(_component_v_avatar, {
              key: 0,
              color: "white",
              size: "21",
              class: _normalizeClass(["shrink-0", { 'mobile-avatar': !_ctx.mobile }])
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["class"]))
          : (_openBlock(), _createBlock(_component_v_avatar, {
              key: 1,
              color: "primary",
              size: "21",
              class: _normalizeClass(["shrink-0", { 'mobile-avatar': !_ctx.mobile }]),
              style: _normalizeStyle(_unref(npsRingStyle))
            }, {
              default: _withCtx(() => [
                _createVNode(ProtectedAvatar, {
                  src: resolvedPhoto.value,
                  size: 21
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["font-bold", _ctx.mobile ? 'text-[10px]' : 'text-[.6rem]'])
                    }, _toDisplayString(avatarInitials.value), 3)
                  ]),
                  _: 1
                }, 8, ["src"])
              ]),
              _: 1
            }, 8, ["class", "style"])),
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.ourTeam)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["flex items-center justify-center gap-[10px] rounded-2xl mb-[3px] px-2 py-0 font-sans font-normal not-italic leading-[14px] tracking-[0.06px] text-[var(--Tertiary-40)]", [
              _unref(defineOurTeamBgColor),
              _ctx.mobile
                ? 'h-[18px] w-fit text-[10px]'
                : 'h-[16px] md:h-[21px] w-[40px] md:w-[53px] text-[8px] md:text-[10px]'
            ]])
              }, "Externo", 2))
            : _createCommentVNode("", true),
          _createVNode(_component_v_tooltip, {
            text: _ctx.name,
            location: "top"
          }, {
            activator: _withCtx(({ props: tooltipProps }) => [
              _createElementVNode("span", _mergeProps(tooltipProps, {
                class: ["two-line-ellipsis text-left text-gray-800 leading-tight cursor-default", [
                  _unref(isAlertTextColor),
                  _ctx.mobile ? 'text-[11px]' : 'text-[9px] md:text-[12px] md:max-w-[100px]'
                ]]
              }), _toDisplayString(_ctx.name), 17)
            ]),
            _: 1
          }, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", {
          class: _normalizeClass(["div3 text-left", [
            _unref(stationIsAlert) ? 'text-white' : 'text-gray-700',
            _ctx.mobile ? 'text-[10px]' : 'text-[8px] md:text-[10px]'
          ]])
        }, _toDisplayString(_ctx.crm), 3)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_unref(stationIsAlert))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_ctx.hasObservations)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      text: "Existe observações"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps({
                          size: "small",
                          color: "warning"
                        }, props, { icon: _unref(mdiTextBoxCheck) }), null, 16, ["icon"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.doctorPending)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 1,
                      text: "Médico pendente"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps({
                          size: "small",
                          color: "primary"
                        }, props, { icon: _unref(mdiAccountAlert) }), null, 16, ["icon"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.doctorConfirmed)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 2,
                      text: "Plantão pendente"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps({
                          size: "small",
                          color: "neutral"
                        }, props, { icon: _unref(mdiClockAlertOutline) }), null, 16, ["icon"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.doctorConfirmed)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 3,
                      text: "Plantão confirmado"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_icon, _mergeProps({
                          size: "small",
                          color: "success"
                        }, props, { icon: _unref(mdiClockCheckOutline) }), null, 16, ["icon"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.doctorStationStatus !== _unref(DoctorStationStatus).SEM_STATUS && !_unref(notShowStatusIcon))
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 4,
                      text: _unref(doctorStationStatusTranslate)[_ctx.doctorStationStatus].text
                    }, {
                      activator: _withCtx(({ props }) => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(doctorStationStatusTranslate)[_ctx.doctorStationStatus].icon), _normalizeProps(_guardReactiveProps(props)), null, 16))
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true),
                (_ctx.exceptionSummaryStatus)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 5,
                      text: _unref(exceptionTooltipText)
                    }, {
                      activator: _withCtx(({ props: tooltipProps }) => [
                        _createVNode(_component_v_icon, _mergeProps(tooltipProps, {
                          size: "small",
                          icon: _unref(exceptionIconPath),
                          color: _unref(exceptionIconColor)
                        }), null, 16, ["icon", "color"])
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true),
                (_unref(flags).enabledPostStation && _ctx.postStationStatus)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 6,
                      text: _unref(postStationTooltipText)
                    }, {
                      activator: _withCtx(({ props: tooltipProps }) => [
                        _createVNode(_component_v_icon, _mergeProps(tooltipProps, {
                          "data-testid": "post-station-status-icon",
                          size: "small",
                          icon: _unref(mdiClockEnd),
                          color: _unref(postStationIconColor)
                        }), null, 16, ["icon", "color"])
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true),
                (_unref(flags).enabledPermanenceRecord && _ctx.permanenceTooltip)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 7,
                      text: _ctx.permanenceTooltip
                    }, {
                      activator: _withCtx(({ props: tooltipProps }) => [
                        _createVNode(PermanenceRecordIcon, _mergeProps(tooltipProps, { "data-testid": "permanence-record-icon" }), null, 16)
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ])
  ], 4))
}
}

})